import React, { useRef, useState, useEffect, useLayoutEffect } from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
const isMobile = browserCheck.isMobile
export const WuhanAnnotationComponent = ({
  content,
  align,
  lineHeight
}: WuhanAnnotationComponentProps) => {
  const countries = require('./countries.csv')
  const [valueWidths, setValueWidths] = useState<[number, number]>([0, 0])
  const [rectHeight, setRectHeight] = useState<number>(0)
  const currentLineHeight = lineHeight
  const v1Node = useRef<SVGTSpanElement>(null)
  const v2Node = useRef<SVGTSpanElement>(null)
  let rectHeightModifier = 1.7
  const spacer = browserCheck.isMobile ? 2 : 2
  const country = countries.find(c => c.iso2c === content.code)
  let countryName = content.de
  if (country !== undefined) {
    console.log(country)
    countryName = country.fr
  }
  if (document.documentMode || /Edge/.test(navigator.userAgent)) {
    rectHeightModifier = 1
  }
  useLayoutEffect(() => {
    function updateNodes() {
      if (v1Node && v1Node.current && !v2Node) {
        setRectHeight(v1Node.current.getBBox().height / rectHeightModifier)

        setValueWidths([v1Node.current.getComputedTextLength(), valueWidths[1]])
      }
      if (v2Node && v2Node.current && !v1Node) {
        setRectHeight(v2Node.current.getBBox().height / rectHeightModifier)

        setValueWidths([valueWidths[0], v2Node.current.getComputedTextLength()])
      }
      if (v2Node.current && v1Node.current) {
        setRectHeight(v1Node.current.getBBox().height / rectHeightModifier)
        setValueWidths([
          v1Node.current.getComputedTextLength(),
          v2Node.current.getComputedTextLength()
        ])
      }
    }
    window.addEventListener('resize', updateNodes)

    updateNodes()
  }, [])
  useEffect(() => {
    setRectHeight(v1Node.current.getBBox().height / rectHeightModifier)
  }, [v1Node.current])
  const nf = new Intl.NumberFormat('fr-CH')

  return (
    <>
      <text textAnchor={align}>
        {content.cases && (
          <tspan className='bold' ref={v1Node}>
            {+content.cases > 9999 ? nf.format(+content.cases) : +content.cases}
          </tspan>
        )}
        {content.death > 0 && (
          <tspan className='red' ref={v2Node} dx={spacer}>
            {'  ' +
              (+content.death > 9999
                ? nf.format(+content.death)
                : +content.death)}
          </tspan>
        )}
        {content.de && (
          <tspan dy={currentLineHeight} x='0'>
            {/* isMobile ? content.de_mobile : content.de */}
            {countryName}
          </tspan>
        )}
      </text>
    </>
  )
}
